<template>
    <div>
        <div v-if="arrayLibros.length > 0">
            <lista_preguntasVue :arrayLibrosDocente="arrayLibros"/>
        </div>
        <div v-else>
            <div class="text-center">
                <h5>No tiene libros asignados a su perfil, por favor comuníquese con su asesor.</h5>
            </div>
        </div>
    </div>
</template>
<script>
const lista_preguntasVue = () => import('../../../../evaluaciones/lista_preguntas.vue');
export default {
    components:{
        lista_preguntasVue,
    },
    data() {
       return{
        usuario:[],
        arrayLibros:[],
       } 
    },
    created() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted(){
        this.getLibros();
    },
    methods: {
        async getLibros() {
            let me = this;
            me.libros_area = []
            let region = localStorage.region
            await this.$http.get(this.$server_url + 'getLibrosDocentes/' + me.usuario.idusuario + '/' + region + '/' + localStorage.periodo_id)
                .then(function (res) {
                    me.arrayLibros = res.data
                })
        }, 
    },
}
</script>